import React from 'react'
import { Box, Divider } from '@mui/material'
import DoorAccess from './DoorAccess'
import MembershipExpiryAlert from './MembershipExpiryAlert'

const SideDrawer = () => {
    return (
        <Box>
            <DoorAccess />
            <Divider sx={{ my: 3 }} />
            <MembershipExpiryAlert />
        </Box>
    )
}

export default SideDrawer